export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt-BR": {
        "secureEnvironment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ambiente Seguro"])}
      },
      "en-US": {
        "secureEnvironment": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Secure Environment"])}
      }
    }
  })
}
